import axios from 'axios'

class ConvidadosApiClient {

    async buscar(compraDiretaId) {
        return await axios.get(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/convidados`)
    }

    async adicionar(compraDiretaId, email) {
        return await axios.post(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/convidados`, {email})
    }

    async excluir(compraDiretaId, id) {
        return await axios.delete(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/convidados/${id}`)
    }

}

export default new ConvidadosApiClient()
